module.exports = __webpack_public_path__ + "img/42600.c59a7dc9.jpg";